import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Pincodemaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.pincodemaster_Id,
          sortable: true,
          cell: (row) => <span>{row.pincodemaster_Id}</span>,
        },
        { name: "Number Pincode", selector: (row, i) => row.num_pincode, sortable: true, cell: (row) => <span>{row.num_pincode}</span>, }, { name: "Number Country Cd", selector: (row, i) => row.num_country_cd, sortable: true, cell: (row) => <span>{row.num_country_cd}</span>, }, { name: "Number State Cd", selector: (row, i) => row.num_state_cd, sortable: true, cell: (row) => <span>{row.num_state_cd}</span>, }, { name: "Number City cd", selector: (row, i) => row.num_city_cd, sortable: true, cell: (row) => <span>{row.num_city_cd}</span>, }, { name: "Number City District cd", selector: (row, i) => row.num_citydistrict_cd, sortable: true, cell: (row) => <span>{row.num_citydistrict_cd}</span>, }, { name: "Text Is Rural", selector: (row, i) => row.txt_is_rural, sortable: true, cell: (row) => <span>{row.txt_is_rural}</span>, }, { name: "Text Pincode Locality", selector: (row, i) => row.txt_pincode_locality, sortable: true, cell: (row) => <span>{row.txt_pincode_locality}</span>, }, { name: "Number Tehsil cd", selector: (row, i) => row.num_tehsil_cd, sortable: true, cell: (row) => <span>{row.num_tehsil_cd}</span>, }, { name: "Date Start Date", selector: (row, i) => row.dat_start_dt, sortable: true, cell: (row) => <span>{row.dat_start_dt}</span>, }, { name: "Date End date", selector: (row, i) => row.dat_end_dt, sortable: true, cell: (row) => <span>{row.dat_end_dt}</span>, }, { name: "Date Insert Date", selector: (row, i) => row.dat_insert_date, sortable: true, cell: (row) => <span>{row.dat_insert_date}</span>, }, { name: "Date Modify Date", selector: (row, i) => row.dat_modify_date, sortable: true, cell: (row) => <span>{row.dat_modify_date}</span>, }, { name: "C Uid", selector: (row, i) => row.c_uid, sortable: true, cell: (row) => <span>{row.c_uid}</span>, }, { name: "C Ts", selector: (row, i) => row.c_ts, sortable: true, cell: (row) => <span>{row.c_ts}</span>, }, { name: "Last Update", selector: (row, i) => row.lastupdate, sortable: true, cell: (row) => <span>{row.lastupdate}</span>, }, { name: "U Ts", selector: (row, i) => row.u_ts, sortable: true, cell: (row) => <span>{row.u_ts}</span>, }, { name: "Health Zone", selector: (row, i) => row.health_zone, sortable: true, cell: (row) => <span>{row.health_zone}</span>, }, { name: "Visibility Flag", selector: (row, i) => row.visibility_flag, sortable: true, cell: (row) => <span>{row.visibility_flag}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.PincodemastereditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      pincodemaster_Id: "",
      num_pincode: '', num_country_cd: '', num_state_cd: '', num_city_cd: '', num_citydistrict_cd: '', txt_is_rural: '', txt_pincode_locality: '', num_tehsil_cd: '', dat_start_dt: '', dat_end_dt: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '', health_zone: '', visibility_flag: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'num_pincode', inputType: 'Text', displayName: 'Number Pincode', validationOptions: { isRequired: false } },
      { fieldName: 'num_country_cd', inputType: 'Text', displayName: 'Number Country Cd', validationOptions: { isRequired: false } },
      { fieldName: 'num_state_cd', inputType: 'Text', displayName: 'Number State Cd', validationOptions: { isRequired: false } },
      { fieldName: 'num_city_cd', inputType: 'Text', displayName: 'Number City cd', validationOptions: { isRequired: false } },
      { fieldName: 'num_citydistrict_cd', inputType: 'Text', displayName: 'Number City District cd', validationOptions: { isRequired: false } },
      { fieldName: 'txt_is_rural', inputType: 'Text', displayName: 'Text Is Rural', validationOptions: { isRequired: false } },
      { fieldName: 'txt_pincode_locality', inputType: 'Text', displayName: 'Text Pincode Locality', validationOptions: { isRequired: false } },
      { fieldName: 'num_tehsil_cd', inputType: 'Text', displayName: 'Number Tehsil cd', validationOptions: { isRequired: false } },
      { fieldName: 'dat_start_dt', inputType: 'Date', displayName: 'Date Start Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_end_dt', inputType: 'Date', displayName: 'Date End date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_insert_date', inputType: 'Date', displayName: 'Date Insert Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_modify_date', inputType: 'Date', displayName: 'Date Modify Date', validationOptions: { isRequired: false } },
      { fieldName: 'c_uid', inputType: 'Text', displayName: 'C Uid', validationOptions: { isRequired: false } },
      { fieldName: 'c_ts', inputType: 'Text', displayName: 'C Ts', validationOptions: { isRequired: false } },
      { fieldName: 'lastupdate', inputType: 'Date', displayName: 'Last Update', validationOptions: { isRequired: false } },
      { fieldName: 'u_ts', inputType: 'Text', displayName: 'U Ts', validationOptions: { isRequired: false } },
      { fieldName: 'health_zone', inputType: 'Text', displayName: 'Health Zone', validationOptions: { isRequired: false } },
      { fieldName: 'visibility_flag', inputType: 'Text', displayName: 'Visibility Flag', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      num_pincode: '', num_country_cd: '', num_state_cd: '', num_city_cd: '', num_citydistrict_cd: '', txt_is_rural: '', txt_pincode_locality: '', num_tehsil_cd: '', dat_start_dt: '', dat_end_dt: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '', health_zone: '', visibility_flag: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      num_pincode: '', num_country_cd: '', num_state_cd: '', num_city_cd: '', num_citydistrict_cd: '', txt_is_rural: '', txt_pincode_locality: '', num_tehsil_cd: '', dat_start_dt: '', dat_end_dt: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '', health_zone: '', visibility_flag: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  PincodemastereditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      pincodemaster_Id: row.pincodemaster_Id,
      num_pincode: row.num_pincode, num_country_cd: row.num_country_cd, num_state_cd: row.num_state_cd, num_city_cd: row.num_city_cd, num_citydistrict_cd: row.num_citydistrict_cd, txt_is_rural: row.txt_is_rural, txt_pincode_locality: row.txt_pincode_locality, num_tehsil_cd: row.num_tehsil_cd, dat_start_dt: row.dat_start_dt, dat_end_dt: row.dat_end_dt, dat_insert_date: row.dat_insert_date, dat_modify_date: row.dat_modify_date, c_uid: row.c_uid, c_ts: row.c_ts, lastupdate: row.lastupdate, u_ts: row.u_ts, health_zone: row.health_zone, visibility_flag: row.visibility_flag,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  PincodemasterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Pincodemaster/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  PincodemastersubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('num_pincode', this.state.num_pincode);
    formData.append('num_country_cd', this.state.num_country_cd);
    formData.append('num_state_cd', this.state.num_state_cd);
    formData.append('num_city_cd', this.state.num_city_cd);
    formData.append('num_citydistrict_cd', this.state.num_citydistrict_cd);
    formData.append('txt_is_rural', this.state.txt_is_rural);
    formData.append('txt_pincode_locality', this.state.txt_pincode_locality);
    formData.append('num_tehsil_cd', this.state.num_tehsil_cd);
    formData.append('dat_start_dt', this.state.dat_start_dt);
    formData.append('dat_end_dt', this.state.dat_end_dt);
    formData.append('dat_insert_date', this.state.dat_insert_date);
    formData.append('dat_modify_date', this.state.dat_modify_date);
    formData.append('c_uid', this.state.c_uid);
    formData.append('c_ts', this.state.c_ts);
    formData.append('lastupdate', this.state.lastupdate);
    formData.append('u_ts', this.state.u_ts);
    formData.append('health_zone', this.state.health_zone);
    formData.append('visibility_flag', this.state.visibility_flag);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Pincodemaster/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.PincodemasterfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ num_pincode: '', num_country_cd: '', num_state_cd: '', num_city_cd: '', num_citydistrict_cd: '', txt_is_rural: '', txt_pincode_locality: '', num_tehsil_cd: '', dat_start_dt: '', dat_end_dt: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '', health_zone: '', visibility_flag: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  PincodemasterupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("pincodemaster_Id", this.state.pincodemaster_Id);
    formData.append('num_pincode', this.state.num_pincode);
    formData.append('num_country_cd', this.state.num_country_cd);
    formData.append('num_state_cd', this.state.num_state_cd);
    formData.append('num_city_cd', this.state.num_city_cd);
    formData.append('num_citydistrict_cd', this.state.num_citydistrict_cd);
    formData.append('txt_is_rural', this.state.txt_is_rural);
    formData.append('txt_pincode_locality', this.state.txt_pincode_locality);
    formData.append('num_tehsil_cd', this.state.num_tehsil_cd);
    formData.append('dat_start_dt', this.state.dat_start_dt);
    formData.append('dat_end_dt', this.state.dat_end_dt);
    formData.append('dat_insert_date', this.state.dat_insert_date);
    formData.append('dat_modify_date', this.state.dat_modify_date);
    formData.append('c_uid', this.state.c_uid);
    formData.append('c_ts', this.state.c_ts);
    formData.append('lastupdate', this.state.lastupdate);
    formData.append('u_ts', this.state.u_ts);
    formData.append('health_zone', this.state.health_zone);
    formData.append('visibility_flag', this.state.visibility_flag);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Pincodemaster/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.PincodemasterfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.PincodemasterfetchHandler();

    //***componentDidMount
  }

  handlenum_pincodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_pincode: fieldValue });
  }; handlenum_country_cdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_country_cd: fieldValue });
  }; handlenum_state_cdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_state_cd: fieldValue });
  }; handlenum_city_cdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_city_cd: fieldValue });
  }; handlenum_citydistrict_cdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_citydistrict_cd: fieldValue });
  }; handletxt_is_ruralChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_is_rural: fieldValue });
  }; handletxt_pincode_localityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_pincode_locality: fieldValue });
  }; handlenum_tehsil_cdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_tehsil_cd: fieldValue });
  }; handledat_start_dtChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_start_dt: fieldValue });
  }; handledat_end_dtChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_end_dt: fieldValue });
  }; handledat_insert_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_insert_date: fieldValue });
  }; handledat_modify_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_modify_date: fieldValue });
  }; handlec_uidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ c_uid: fieldValue });
  }; handlec_tsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ c_ts: fieldValue });
  }; handlelastupdateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ lastupdate: fieldValue });
  }; handleu_tsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ u_ts: fieldValue });
  }; handlehealth_zoneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ health_zone: fieldValue });
  }; handlevisibility_flagChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ visibility_flag: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this pincodemaster?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('pincodemaster_Id', row.pincodemaster_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Pincodemaster/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.PincodemasterfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Pincode Master</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Pincodemaster</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Pincode</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_pincodeChange} className="form-control" name="num_pincode" value={this.state.num_pincode} required="required" placeholder="Enter Number Pincode" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_pincode} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Country Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_country_cdChange} className="form-control" name="num_country_cd" value={this.state.num_country_cd} required="required" placeholder="Enter Number Country Cd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_country_cd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number State Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_state_cdChange} className="form-control" name="num_state_cd" value={this.state.num_state_cd} required="required" placeholder="Enter Number State Cd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_state_cd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number City cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_city_cdChange} className="form-control" name="num_city_cd" value={this.state.num_city_cd} required="required" placeholder="Enter Number City cd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_city_cd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number City District cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_citydistrict_cdChange} className="form-control" name="num_citydistrict_cd" value={this.state.num_citydistrict_cd} required="required" placeholder="Enter Number City District cd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_citydistrict_cd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Is Rural</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_is_ruralChange} className="form-control" name="txt_is_rural" value={this.state.txt_is_rural} required="required" placeholder="Enter Text Is Rural" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_is_rural} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Pincode Locality</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_pincode_localityChange} className="form-control" name="txt_pincode_locality" value={this.state.txt_pincode_locality} required="required" placeholder="Enter Text Pincode Locality" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_pincode_locality} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Tehsil cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_tehsil_cdChange} className="form-control" name="num_tehsil_cd" value={this.state.num_tehsil_cd} required="required" placeholder="Enter Number Tehsil cd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_tehsil_cd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Start Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_start_dtChange} className="form-control" name="dat_start_dt" value={this.state.dat_start_dt} required="required" placeholder="Enter Date Start Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_start_dt} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date End date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_end_dtChange} className="form-control" name="dat_end_dt" value={this.state.dat_end_dt} required="required" placeholder="Enter Date End date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_end_dt} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Insert Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_insert_dateChange} className="form-control" name="dat_insert_date" value={this.state.dat_insert_date} required="required" placeholder="Enter Date Insert Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_insert_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Modify Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_modify_dateChange} className="form-control" name="dat_modify_date" value={this.state.dat_modify_date} required="required" placeholder="Enter Date Modify Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_modify_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>C Uid</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlec_uidChange} className="form-control" name="c_uid" value={this.state.c_uid} required="required" placeholder="Enter C Uid" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_uid} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>C Ts</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlec_tsChange} className="form-control" name="c_ts" value={this.state.c_ts} required="required" placeholder="Enter C Ts" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_ts} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Last Update</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handlelastupdateChange} className="form-control" name="lastupdate" value={this.state.lastupdate} required="required" placeholder="Enter Last Update" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.lastupdate} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>U Ts</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleu_tsChange} className="form-control" name="u_ts" value={this.state.u_ts} required="required" placeholder="Enter U Ts" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.u_ts} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Health Zone</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlehealth_zoneChange} className="form-control" name="health_zone" value={this.state.health_zone} required="required" placeholder="Enter Health Zone" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.health_zone} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Visibility Flag</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlevisibility_flagChange} className="form-control" name="visibility_flag" value={this.state.visibility_flag} required="required" placeholder="Enter Visibility Flag" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.visibility_flag} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.PincodemastersubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Pincodemaster</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Pincode</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_pincodeChange} className="form-control" name="num_pincode" value={this.state.num_pincode} required="required" placeholder="Enter Number Pincode" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_pincode} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Country Cd</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_country_cdChange} className="form-control" name="num_country_cd" value={this.state.num_country_cd} required="required" placeholder="Enter Number Country Cd" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_country_cd} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number State Cd</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_state_cdChange} className="form-control" name="num_state_cd" value={this.state.num_state_cd} required="required" placeholder="Enter Number State Cd" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_state_cd} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number City cd</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_city_cdChange} className="form-control" name="num_city_cd" value={this.state.num_city_cd} required="required" placeholder="Enter Number City cd" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_city_cd} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number City District cd</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_citydistrict_cdChange} className="form-control" name="num_citydistrict_cd" value={this.state.num_citydistrict_cd} required="required" placeholder="Enter Number City District cd" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_citydistrict_cd} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Is Rural</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_is_ruralChange} className="form-control" name="txt_is_rural" value={this.state.txt_is_rural} required="required" placeholder="Enter Text Is Rural" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_is_rural} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Pincode Locality</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_pincode_localityChange} className="form-control" name="txt_pincode_locality" value={this.state.txt_pincode_locality} required="required" placeholder="Enter Text Pincode Locality" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_pincode_locality} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Tehsil cd</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_tehsil_cdChange} className="form-control" name="num_tehsil_cd" value={this.state.num_tehsil_cd} required="required" placeholder="Enter Number Tehsil cd" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_tehsil_cd} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Start Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_start_dtChange} className="form-control" name="dat_start_dt" value={this.state.dat_start_dt} required="required" placeholder="Enter Date Start Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_start_dt} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date End date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_end_dtChange} className="form-control" name="dat_end_dt" value={this.state.dat_end_dt} required="required" placeholder="Enter Date End date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_end_dt} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Insert Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_insert_dateChange} className="form-control" name="dat_insert_date" value={this.state.dat_insert_date} required="required" placeholder="Enter Date Insert Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_insert_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Modify Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_modify_dateChange} className="form-control" name="dat_modify_date" value={this.state.dat_modify_date} required="required" placeholder="Enter Date Modify Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_modify_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>C Uid</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlec_uidChange} className="form-control" name="c_uid" value={this.state.c_uid} required="required" placeholder="Enter C Uid" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_uid} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>C Ts</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlec_tsChange} className="form-control" name="c_ts" value={this.state.c_ts} required="required" placeholder="Enter C Ts" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_ts} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Last Update</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handlelastupdateChange} className="form-control" name="lastupdate" value={this.state.lastupdate} required="required" placeholder="Enter Last Update" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.lastupdate} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>U Ts</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleu_tsChange} className="form-control" name="u_ts" value={this.state.u_ts} required="required" placeholder="Enter U Ts" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.u_ts} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Health Zone</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlehealth_zoneChange} className="form-control" name="health_zone" value={this.state.health_zone} required="required" placeholder="Enter Health Zone" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.health_zone} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Visibility Flag</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlevisibility_flagChange} className="form-control" name="visibility_flag" value={this.state.visibility_flag} required="required" placeholder="Enter Visibility Flag" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.visibility_flag} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.PincodemasterupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}